import { CommonModule } from '@angular/common';
import { InjectionToken, NgModule } from '@angular/core';
import { BuildingBorderQuery } from './building-borders/state/building-border.query';
import { BuildingBorderService } from './building-borders/state/building-border.service';
import { BuildingsModule } from './buildings/buildings.module';
import { BuildingQuery } from './buildings/state/building.query';
import { BuildingService } from './buildings/state/building.service';
import { EdgesModule } from './edges/edges.module';
import { EdgeQuery } from './edges/state/edge.query';
import { EdgeService } from './edges/state/edge.service';
import { GeometricFormComponent } from './shared/geometric-form/geometric-form.component';
import { GeometricFormQuery } from './state/geometric-form.query';
import { GeometricFormService } from './state/geometric-form.service';
import { GeometricFormType } from './state/geometric-form.type';
import { VertexQuery } from './vertexes/state/vertex.query';
import { VertexService } from './vertexes/state/vertex.service';
import { VertexesModule } from './vertexes/vertexes.module';

export const GEOMETRIC_FORM_SERVICE =
  new InjectionToken<GeometricFormService<any>>('GeometricFormService');

export const GEOMETRIC_FORM_QUERY =
  new InjectionToken<GeometricFormQuery<GeometricFormType>>('GeometricFormService');

@NgModule({
  declarations: [GeometricFormComponent],
  imports: [
    CommonModule,
    BuildingsModule,
    VertexesModule,
    EdgesModule
  ],
  providers: [
    { provide: GEOMETRIC_FORM_SERVICE, useClass: VertexService, multi: true },
    { provide: GEOMETRIC_FORM_SERVICE, useClass: EdgeService, multi: true },
    { provide: GEOMETRIC_FORM_SERVICE, useClass: BuildingService, multi: true },
    { provide: GEOMETRIC_FORM_SERVICE, useClass: BuildingBorderService, multi: true },

    { provide: GEOMETRIC_FORM_QUERY, useClass: VertexQuery, multi: true },
    { provide: GEOMETRIC_FORM_QUERY, useClass: EdgeQuery, multi: true },
    { provide: GEOMETRIC_FORM_QUERY, useClass: BuildingQuery, multi: true },
    { provide: GEOMETRIC_FORM_QUERY, useClass: BuildingBorderQuery, multi: true },
  ]
})
export class GeometricFormModule { }


